import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { Typography } from '~/libs/ui/atoms/Typography';
import { Breadcrumbs, BreadcrumbsItem } from '~/libs/ui/atoms/Breadcrumbs';

function MetodikaHeader() {
	const breadcrumbs: BreadcrumbsItem[] = [
		{ name: 'Dostupnosti', link: '/availability' },
		{ name: 'Vyhledávání', link: '/availability' },
		{ name: 'Metodika' },
	];

	return (
		<div className='w-full pt-2 pb-5 border-b border-gray-200 bg-cBlue-50'>
			<div className='max-w-[1260px] mx-auto px-[40px]'>
				<Breadcrumbs list={breadcrumbs} />
				<Typography level={2} weight='font-bold' color='cBlue-800' className='mb-2'>
					Metodika
				</Typography>
				<Link
					to='/availability'
					className='relative inline-flex items-center mr-4 pl-7 pr-2.5 py-1 rounded border font-semibold leading-4 text-[12px] cursor-pointer tracking-wide border-cPurple-400/40 text-cPurple-600 bg-cPurple-100 bg-opacity-20 transition-colors hover:bg-black hover:border-black hover:text-white'
				>
					<FaArrowLeft className='absolute left-1.5 top-1/2 -mt-2 w-4 h-4' />
					Zpět na vyhledávání
				</Link>
			</div>
		</div>
	);
}

export function AvailabilityMetodikaPage() {
	return (
		<div className='w-full h-full bg-gray-50 overflow-auto'>
			<MetodikaHeader />

			<div className='max-w-[1260px] mx-auto px-10 py-10 font-display'>
				<div className='max-w-3xl space-y-8'>
					<section className='space-y-4 text-gray-900'>
						<p className='leading-7'>
							Monitor Dostupnosti LP automaticky počítá dostupnost léčivých přípravků ve smyslu{' '}
							<strong>§ 39c odst. 2 písm. a) zákona č. 48/1997 Sb.</strong>, o veřejném zdravotním pojištění pro zvolený
							kvartál. Pro výpočet je použita metodika využívána Státní ústavem pro kontrolu léčiv ve správních
							řízeních.
						</p>
						<p className='leading-7'>
							Dostupnost léčivého přípravku je vypočítána vždy pro <strong>uzavřený kvartál</strong> ze tří příslušných
							hlášení DIS-13. Výpočet probíhá z celkového objemu doporučených denních dávek (<strong>DDD</strong>) v
							dané ATC skupině, která se dále může dělit na přípravky obsažené v referenční skupině (<strong>RS</strong>
							) a bez referenční skupiny.
						</p>
						<p className='leading-7'>
							V případě absence DDD je pro výpočet dostupnosti využito údajů o počtu obvyklých denních terapeutických
							dávek v balení (<strong>ODTD</strong>) ze Seznamu cen a úhrad LP (<strong>SCAU</strong>), případně
							informace o počtu balení. Všechny uvedené hodnoty jsou vždy dostupné v exportovaném xlsx souboru.
						</p>
						<p className='leading-7'>
							Do výpočtu jsou zahrnuty dodávky léčivých přípravků následujících typů dodavatelů:{' '}
							<strong>
								lékárna, lékař, osoba poskytující zdravotní péči, transfúzní služba, zdravotnické zařízení a hygienická
								stanice.
							</strong>
						</p>
					</section>

					<section className='bg-cBlue-50 border-l-4 border-cBlue-500 px-6 py-5 rounded-r space-y-2'>
						<p className='leading-7 text-gray-900'>
							Léčivý přípravek je dostupný, když jeho podíl v ATC skupině, případně kombinaci ATC a RS, dosáhne hodnoty{' '}
							<strong>alespoň 5 % z celkového počtu</strong> (novelou zákona č. 48/1997 Sb. došlo od 1. 1. 2026 k
							posunutí hranice posuzování dostupnosti ze 3 % na 5 %). Výpočet obsahuje matematické zaokrouhlení na dvě
							desetinná místa.
						</p>
						<p className='leading-7 text-gray-900'>
							Monitor Dostupnosti LP zobrazuje informaci o dohodnutých nejvyšších cenách (<strong>DNC</strong>) a
							dohodách o úhradě (<strong>DoÚ</strong>) uvedených v aktuálním SCAU.
						</p>
					</section>

					<section className='space-y-4'>
						<h3 className='text-lg font-bold text-gray-900 uppercase tracking-wide'>Zdroje</h3>
						<div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
							<div className='bg-white border border-gray-200 rounded p-5 space-y-1'>
								<p className='text-labelsmall text-gray-500 uppercase tracking-wide'>Zdroj</p>
								<p className='text-base font-bold text-gray-900'>DIS-13</p>
								<p className='text-sm text-gray-700 leading-5'>
									Souhrnné informace o dodávkách léčivých přípravků distributorům a provozovatelům oprávněným k výdeji v
									ČR a v zahraničí
								</p>
								<p className='text-labelsmall text-gray-500 pt-1'>Aktualizováno ke dni: 06.05.2026</p>
							</div>
							<div className='bg-white border border-gray-200 rounded p-5 space-y-1'>
								<p className='text-labelsmall text-gray-500 uppercase tracking-wide'>Zdroj</p>
								<p className='text-base font-bold text-gray-900'>SCAU</p>
								<p className='text-sm text-gray-700 leading-5'>
									Seznam léčiv a PZLÚ hrazených ze zdravotního pojištění
								</p>
								<p className='text-labelsmall text-gray-500 pt-1'>Aktualizováno ke dni: 01.05.2026</p>
							</div>
						</div>
					</section>

					<section className='border-t border-gray-200 pt-4'>
						<p className='text-gray-700 leading-7'>
							Máte dotazy k metodice? Kontaktujte nás na{' '}
							<a
								href='mailto:support@cogvio.com'
								className='text-cBlue-500 hover:text-blue-700 underline underline-offset-2 decoration-2'
							>
								support@cogvio.com
							</a>
						</p>
					</section>
				</div>
			</div>
		</div>
	);
}
